var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideBySide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Synth-Theme-(Title-Change)",
    transform: "translate(-648.000000, -308.000000)",
    fill: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "split-view.1",
    transform: "translate(648.000000, 308.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72727273,2.76363636 C1.34569227,2.76363636 1.03636364,3.072965 1.03636364,3.45454545 L1.03636364,15.5454545 C1.03636364,15.9270091 1.34569227,16.2363636 1.72727273,16.2363636 L5.18217227,16.2363636 L5.18217227,17.2727273 L1.72727273,17.2727273 C0.773325909,17.2727273 0,16.4994273 0,15.5454545 L0,3.45454545 C0,2.50059864 0.773325909,1.72727273 1.72727273,1.72727273 L5.18217227,1.72727273 L5.18217227,2.76363636 L1.72727273,2.76363636 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8181818,16.2363636 C14.1997364,16.2363636 14.5090909,15.9270091 14.5090909,15.5454545 L15.5454545,15.5454545 C15.5454545,16.4994273 14.7721545,17.2727273 13.8181818,17.2727273 L13.8181818,16.2363636 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5090909,3.45454545 C14.5090909,3.072965 14.1997364,2.76363636 13.8181818,2.76363636 L13.8181818,1.72727273 C14.7721545,1.72727273 15.5454545,2.50059864 15.5454545,3.45454545 L14.5090909,3.45454545 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "10.3485227 2.76363636 10.3485227 1.72727273 12.0833091 1.72727273 12.0833091 2.76363636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "10.3485227 17.2727273 10.3485227 16.2363636 12.0833091 16.2363636 12.0833091 17.2727273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "15.5454545 13.8085955 14.5090909 13.8085955 14.5090909 12.10775 15.5454545 12.10775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "15.5454545 10.3582818 14.5090909 10.3582818 14.5090909 8.63308182 15.5454545 8.63308182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "15.5454545 6.90794227 14.5090909 6.90794227 14.5090909 5.18123955 15.5454545 5.18123955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.25454545 19 7.25454545 0 8.29090909 0 8.29090909 19"
  })))), "\n\u0327");
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBySide);
export default __webpack_public_path__ + "static/media/side_by_side.d3ca59fa.svg";
export { ForwardRef as ReactComponent };